export const GET_AVERIAS_LIST_SUCCESS = 'GET_AVERIAS_LIST_SUCCESS';
export const GET_AVERIAS_LIST_FAIL = 'GET_AVERIAS_LIST_FAIL';

export const GET_AVERIAS_SUCCESS = 'GET_AVERIAS_SUCCESS';
export const GET_AVERIAS_FAIL = 'GET_AVERIAS_FAIL';  